import { AddInventoriesPayload } from '@components/loadingSchedule/AddNewInventories';
import { isEmpty } from 'lodash';

export const validateAddInventories = (inventories: AddInventoriesPayload[]) => {
  let errors: any = [];
  
  inventories.map(inv => {
    const {
      item,
      quantity,
      unit
    } = inv;

    let error: any = {};

    if(isEmpty(item)) error["name"] = "Nama barang wajib diisi";
    if(isEmpty(quantity)) error["quantity"] = "Wajib diisi";
    if(isEmpty(unit)) error["unit"] = "Satuan wajib diisi";

    if(!isEmpty(error)) errors.push(error);
    
    return inv;
  });
  
  return {
    errors,
    isValid: errors.length === 0
  };
};